import React from "react";
import Hero from "./Hero";
import Info from "./Info";

function AboutPage() {
  return (
    <>
      <Hero />
      <Info />
    </>
  );
}

export default AboutPage;
